// extracted by mini-css-extract-plugin
module.exports = {"opcoes":"Opcoes_opcoes__1R3sg"};